import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { themecolor } from "../Navigation";
import { TableCell, TableRow } from "@mui/material";
import { withStyles } from "@material-ui/core/styles";
import { AiFillAccountBook, AiFillPayCircle } from "react-icons/ai";
// import { TbSwitchHorizontal } from "react-icons/tb";
import { BiCustomize } from "react-icons/bi";
import { AiOutlineTransaction } from "react-icons/ai";
import { GiBlackBook } from "react-icons/gi";
import { SiSoundcharts } from "react-icons/si";
import { HiTemplate } from "react-icons/hi";
import PostAddIcon from "@mui/icons-material/PostAdd";
// import FolderCopyIcon from '@mui/icons-material/FolderCopy';
import SettingsIcon from "@mui/icons-material/Settings";
import ConfirmationNumberIcon from "@mui/icons-material/ConfirmationNumber";
import PaidIcon from "@mui/icons-material/Paid";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
// import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
// import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import MapsHomeWorkIcon from "@mui/icons-material/MapsHomeWork";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import { FcLineChart } from "react-icons/fc";
import { FaBalanceScale } from "react-icons/fa";
import DashboardIcon from "@mui/icons-material/Dashboard";
import { BsCashStack } from "react-icons/bs";
import SummarizeIcon from "@mui/icons-material/Summarize";
import { AlertBar } from "../Alert/AlertBar";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import CurrencyRubleIcon from "@mui/icons-material/CurrencyRuble";
import DataUsageIcon from "@mui/icons-material/DataUsage";
import BadgeIcon from "@mui/icons-material/Badge";
import MoneyOffIcon from "@mui/icons-material/MoneyOff";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import { GrTransaction } from "react-icons/gr";
import SavingsIcon from "@mui/icons-material/Savings";
import { ReactComponent as ReceivableAging } from "../images/ReceivableAging.svg";
import { ReactComponent as ReceivableCustomerBalance } from "../images/ReceivableCustomerBalance.svg";
import { ReactComponent as ReceivableInvoiceList } from "../images/ReceivableInvoiceList.svg";
import { ReactComponent as ReceivableSummary } from "../images/AccountReceivableSummary.svg";
import { ReactComponent as GSTReportIcon } from "../images/gst.svg";
import { ReactComponent as GST1ReportIcon } from "../images/GST1.svg";
import { ReactComponent as GST2ReportIcon } from "../images/GST2.svg";
import { ReactComponent as GST3ReportIcon } from "../images/GST3.svg";
import { ReactComponent as OverDueIcon } from "../images/overdue.svg";
import { GrDocumentConfig } from "react-icons/gr";
import { ReactComponent as PermissionModule } from "../images/PermissionModule.svg";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import { ReactComponent as AccountNumbering } from "../images/AccountNumbering.svg";
import { ReactComponent as ProjectGroup } from "../images/ProjectGroup.svg";
import { ReactComponent as ItemsHSNcode } from "../images/ItemsHSN.svg";
import { ReactComponent as TagIcon } from "../images/Tag.svg";
import { ReactComponent as ReconciliationIcon } from "../images/reconciliation.svg";
import { ReactComponent as BankReconciliationIcon } from "../images/buildings.svg";
import { ReactComponent as TaxIcon } from "../images/TaxConf.svg";
import { ReactComponent as TaxSection } from "../images/TDSSection.svg";
import { ReactComponent as Daybook } from "../images/DaybookIcon2.svg";
import { ReactComponent as Liabilities } from "../images/liabilitiesIcon.svg";
import { ReactComponent as Payable } from "../images/payableIcon.svg";
import { ReactComponent as KYCIcon } from "../images/kyc1.svg";
import { ReactComponent as AccountType } from "../images/accountType1.svg";
import { ReactComponent as TaxRules } from "../images/TDSRule.svg";

export const amountLength = 15;

export const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: ` ${themecolor} !important`,
    padding: "8px 5px!important",
    color: "white !important",
    fontSize: "15px !important",
    width: "fit-content",
  },
  body: {
    fontSize: 13,
    fontWeight: 400,
    padding: "5px 3px!important",
    color: "#555",
    // border:"1px solid black",
    // width: 'fit-content !important',
  },
}))(TableCell);

export const StyledTableRow = withStyles(() => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: "#fff",
    },
  },
}))(TableRow);

// keys for import
export const keys = {
  accountKey: "@cc0unt1m90r773m91@73",
  accountGroupKey: "@cc0untgR0u91m90r773m91@73",
  accountTypeKey: "@cc0unt7y931m90r773m91@73",
  transactionKey: "@cc0unt7r@ns@c7i0n1m90r773m91@73",
};

// =================Nav Menus==================//
export const navigationMenus = [
  {
    id: 1,
    name: "Dashboard",
    subName: "Dashboard",
    path: "/dashboard",
    subPath: "/dashboard",
    icon: <DashboardIcon size={20} style={{ color: "#fff" }} />,
  },

  {
    id: 2,
    name: "Chart Of Accounts",
    subName: "Accounts",
    apiEndpoint: "/account/v1/get",
    path: "/account",
    subPath: "/addAccount",
    icon: <SiSoundcharts size={20} style={{ color: "#fff" }} />,
  },
  {
    id: 3,
    name: "Reports",
    subName: "Reports",
    icon: <PostAddIcon style={{ color: "#fff" }} />,
    subMenus: [
      {
        id: "3.1",
        name: "Daybook",
        path: "/daybook",
        subName: "Daybook",
        subPath: "/addTransaction",
        icon: <Daybook size={20} style={{ color: "#fff" }} />,
      },
      {
        id: "3.2",
        name: "Trial Balance",
        subName: "Trial Bal",
        apiEndpoint: "/account-transaction/v1/account/group/tree/list",
        path: "/trialBalance",
        icon: <GiBlackBook size={20} style={{ color: "#fff" }} />,
      },
      {
        id: "3.3",
        name: "Bank Book",
        path: "/bankBook",
        subName: "Bank Book",
        icon: <AccountBalanceIcon size={20} style={{ color: "#fff" }} />,
      },
      {
        id: "3.4",
        name: "Fixed Assets",
        subName: "Fix Asset",
        path: "/fixedAssets",
        icon: <MapsHomeWorkIcon size={20} style={{ color: "#fff" }} />,
      },
      {
        id: "3.5",
        name: "Liabilities",
        subName: "Liabilities",
        path: "/liabilities",
        icon: <Liabilities size={20} style={{ color: "#fff" }} />,
      },
      {
        id: "3.6",
        name: "P&L Statement",
        subName: "P&L Statement",
        path: "/profitLoss",
        icon: (
          <FcLineChart size={20} style={{ color: "#fff", fontSize: "12px" }} />
        ),
      },
      {
        id: "3.7",
        name: "Balance Sheet",
        subName: "Bal Sheet",
        path: "/balanceSheet",
        icon: <FaBalanceScale size={20} style={{ color: "#fff" }} />,
      },
      {
        id: "3.8",
        name: "Cash Flow",
        subName: "Cash flow",
        path: "/cashflow",
        icon: <BsCashStack size={20} style={{ color: "#fff" }} />,
      },
      // {
      //   id: "3.9",
      //   name: "GST Report",
      //   subName: "GST",
      //   path: "/gstReport",
      //   icon: <TbReport size={20} style={{ color: "#fff" }} />
      // },
      // {
      //   id: 1.10,
      //   name: "TDS Report",
      //   subName: "TDS",
      //   path: "/tdsReport",
      //   icon: <TbReportAnalytics size={20} style={{ color: "#fff" }} />
      // }
    ],
  },

  {
    id: 4,
    name: "Master Management",
    subName: "Master",
    icon: <SettingsIcon size={20} style={{ color: "#fff" }} />,
    subMenus: [
      {
        id: "4.1",
        name: "Account Type",
        subName: "Acc Type",
        path: "/accountType",
        subPath: "/addAccountType",
        icon: <AccountType size={20} style={{ color: "#fff" }} />,
      },
      {
        id: "4.2",
        name: "Account Group",
        subName: "Acc Group",
        path: "/accountGroup",
        subPath: "/addAccountGroup",
        icon: <AccountBalanceIcon size={20} style={{ color: "#fff" }} />,
      },
      {
        id: "4.3",
        name: "Report Group",
        subName: "Report Group",
        path: "/reportGroup",
        subPath: "/addReportGroup",
        icon: <AiFillAccountBook size={20} style={{ color: "#fff" }} />,
      },
      {
        id: "4.4",
        name: "KYC Implementation",
        subName: "KYC Config",
        path: "/kycImplemenation",
        subPath: null,
        icon: <KYCIcon size={20} style={{ color: "#fff" }} />,
      },
      {
        id: "4.5",
        path: "/preferences",
        subPath: null,
        name: "Preferences",
        subName: "Preference",
        icon: <ConfirmationNumberIcon size={20} style={{ color: "#fff" }} />,
      },
      {
        id: "4.6",
        path: "/narration",
        subPath: null,
        name: "Narration Config",
        subName: "Narration",
        icon: <ConfirmationNumberIcon size={20} style={{ color: "#fff" }} />,
      },
      {
        id: "4.8",
        path: "/account-transaction-type",
        subPath: null,
        name: "Account Transaction Type",
        subName: "Transaction Type",
        icon: <GrTransaction size={20} style={{ color: "#fff" }} />,
      },
      {
        id: "4.9",
        name: "Company Configuration",
        subName: "Company Config",
        path: "/company-configuration",
        subPath: null,
        icon: <GrDocumentConfig size={20} style={{ color: "#fff" }} />,
      },
      {
        id: "4.10",
        name: "Account Group Configuration",
        subName: "Acc Group Config",
        path: "/add-account-group-configurations",
        subPath: null,
        icon: <AccountTreeIcon size={20} style={{ color: "#fff" }} />,
      },
      {
        id: "4.11",
        name: "Account Numbering",
        subName: "Acc Numbering",
        path: "/add-account-numbering",
        subPath: null,
        icon: <AccountNumbering size={20} style={{ color: "#fff" }} />,
      },
      {
        id: "4.7",
        path: "/account-code",
        subPath: null,
        name: "Account Code",
        subName: "Acc Code",
        icon: <AdminPanelSettingsIcon size={20} style={{ color: "#fff" }} />,
      },
      {
        id: "4.12",
        name: "Project Group",
        subName: "Project Group",
        path: "/project-group",
        subPath: null,
        icon: <ProjectGroup size={20} style={{ color: "#fff" }} />,
      },
      {
        id: "4.13",
        name: "Tags",
        subName: "Tags",
        path: "/tags",
        subPath: null,
        icon: <TagIcon size={20} style={{ color: "#fff" }} />,
      },
      // {
      //   id: "4.13",
      //   name: "TDS Rule",
      //   subName: "TDS",
      //   path: "/tax-configuration",
      //   subPath: null,
      //   icon: <TDSIcon size={20} style={{ color: "#fff" }} />,
      // },
    ],
  },

  {
    id: 5,
    name: "Voucher",
    subName: "Voucher",
    path: "/voucherTemplate",
    icon: <BiCustomize size={20} style={{ color: "#fff" }} />,
    // subMenus: [
    //   {
    //     id: "5.1",
    //     name: "Voucher Template",
    //     path: "/voucherTemplate",
    //     subName: "Template",
    //     icon: <BiCustomize size={20} style={{ color: "#fff" }} />,
    //   },
    // ],
  },

  {
    id: 6,
    name: "Third Party Api Integration",
    subName: "API",
    // name: "Vendor Template",
    // subName: "Vendor",
    path: "/vendorTemplate",
    icon: <HiTemplate size={20} style={{ color: "#fff" }} />,
    // subMenus: [
    //   {
    //     id: "6.1",
    //     name: "Template Config",
    //     path: "/vendorTemplate",
    //     subName: "Temp Config",
    //     icon: <AiFillSetting size={20} style={{ color: "#fff" }} />,
    //   },
    //   // More vendor template items...
    // ],
  },

  {
    id: 7,
    name: "Reports Configurations",
    subName: "Configurations",
    path: "/reportsMaster",
    subPath: "/reportsMaster",
    icon: <SummarizeIcon size={20} style={{ color: "#fff" }} />,
  },
  {
    id: 8,
    name: "Payable Reports",
    subName: "Payable",
    icon: <Payable size={20} style={{ color: "#fff" }} />,
    subMenus: [
      {
        id: "8.1",
        name: "Aging Summary",
        subName: "Aging",
        path: "/aging-Summary-Details",
        subPath: null,
        icon: <DataUsageIcon size={20} style={{ color: "#fff" }} />,
      },
      {
        id: "8.2",
        name: "Vendor Balance Summary",
        subName: "Vendor Bal",
        path: "/vendor-Balance-Summary",
        subPath: null,
        icon: <BadgeIcon size={20} style={{ color: "#fff" }} />,
      },
      {
        id: "8.3",
        name: "Unpaid Bills Details",
        subName: "Unpaid Bill",
        path: "/unpaid-Bills-Details",
        subPath: null,
        icon: <MoneyOffIcon size={20} style={{ color: "#fff" }} />,
      },
      {
        id: "8.4",
        name: "Accounts Payable Summary",
        subName: "Acc Payable",
        path: "/accounts-Payable-Summary",
        subPath: null,
        icon: <AccountBalanceWalletIcon size={20} style={{ color: "#fff" }} />,
      },
    ],
  },
  {
    id: 9,
    name: "Receivable Reports",
    subName: "Receivable",
    icon: <SavingsIcon size={20} style={{ color: "#fff" }} />,
    subMenus: [
      {
        id: "9.1",
        name: "Receivable Aging Summary",
        subName: "Aging",
        path: "/receivable/aging-summary",
        subPath: null,
        icon: <ReceivableAging size={2} style={{ color: "#fff" }} />,
      },
      {
        id: "9.2",
        name: "Customer Balance Summary",
        subName: "Cust Balance",
        path: "/receivable/customer-balance-summary",
        subPath: null,
        icon: <ReceivableCustomerBalance size={2} style={{ color: "#fff" }} />,
      },
      {
        id: "9.3",
        name: "Invoice List",
        subName: "Invoice",
        path: "/receivable/invoice-list-summary",
        subPath: null,
        icon: <ReceivableInvoiceList size={2} style={{ color: "#fff" }} />,
      },
      {
        id: "9.4",
        name: "Account Receivable Summary",
        subName: "Acc Receivable",
        path: "/receivable/account-receivable-summary",
        subPath: null,
        icon: <ReceivableSummary size={10} style={{ color: "#fff" }} />,
      },
    ],
  },
  {
    id: 10,
    name: "Over Due Analysis",
    subName: "Over Due",
    apiEndpoint: "/account/v1/get",
    path: "/over-due-analysis",
    subPath: "/over-due-analysis",
    icon: <OverDueIcon size={20} style={{ color: "#fff" }} />,
  },
  {
    id: 11,
    name: "GST",
    subName: "GST",
    path: "/gst/gst-details-portal",
    subPath: "/gst/gst-details-portal",
    icon: <GSTReportIcon size={20} style={{ color: "#fff" }} />,
    // subMenus: [
    //   {
    //     id: "11.1",
    //     name: "GSTR-1",
    //     subName: "GSTR-1",
    //     path: "/gst-portal-login",
    //     subPath: null,
    //     icon: <GST1ReportIcon size={2} style={{ color: "#fff" }} />,
    //   },
    //   {
    //     id: "11.2",
    //     name: "GSTR-2",
    //     subName: "GSTR-2",
    //     path: "/gst/gst-2",
    //     subPath: null,
    //     icon: <GST2ReportIcon size={2} style={{ color: "#fff" }} />,
    //   },
    //   {
    //     id: "11.3",
    //     name: "GSTR-3B",
    //     subName: "GSTR-3B",
    //     path: "/gst/gst-3B",
    //     subPath: null,
    //     icon: <GST3ReportIcon size={2} style={{ color: "#fff" }} />,
    //   },
    // ],
  },
  {
    id: 12,
    name: "Items & HSN Setup",
    subName: "Items HSN",
    // apiEndpoint: "",
    path: "/items-hsncode-management",
    subPath: "/items-hsncode-management",
    icon: <ItemsHSNcode size={20} style={{ color: "#fff" }} />,
  },
  {
    id: 13,
    name: "Tax Configuration",
    subName: "Tax Config",
    path: null,
    icon: <TaxIcon size={20} style={{ color: "#fff" }} />,
    subMenus: [
      {
        id: "13.1",
        name: "Tax Section",
        path: "/tax-configuration",
        subName: "Section",
        icon: <TaxSection size={20} style={{ color: "#fff" }} />,
      },
      {
        id: "13.2",
        name: "Tax Rule's",
        path: "/tax-configuration/tax-rule",
        subName: "Rules",
        icon: <TaxRules size={20} style={{ color: "#fff" }} />,
      },
    ],
  },
  {
    id: 13.1,
    name: "Reconciliation",
    subName: "Reconciliation",
    icon: <ReconciliationIcon size={20} style={{ color: "#fff" }} />,
    subMenus: [
      {
        id: "13.1.1",
        name: "Bank Reconciliation",
        subName: "BR",
        path: "/bank-reconciliation",
        subPath: null,
        icon: <BankReconciliationIcon size={6} style={{ color: "#fff" }} />,
      },
    ],
  },
  {
    id: 14,
    name: "Settings",
    subName: "Settings",
    icon: <SettingsIcon size={20} style={{ color: "#fff" }} />,
    subMenus: [
      {
        id: "14.1",
        name: "Role & Permission",
        subName: "R&P",
        path: "/role-permission-mapping",
        subPath: null,
        icon: <PermissionModule size={6} style={{ color: "#fff" }} />,
      },
    ],
  },
];

export const navRoutes = [
  {
    id: 1,
    path: "/dashboard",
  },
  {
    id: 20,
    path: "/account",
    subMenus: [{ id: 20.1, path: "/account/display-account-correction" }],
  },

  {
    id: 25,
    path: "/AccountSiteConfiguration",
  },

  {
    id: 21,
    path: "/generalLedger",
  },

  {
    id: 22,
    path: "/pendingApprovals",
  },

  {
    id: 2,
    path: "/addAccount",
  },
  {
    id: 3,
    name: "Reports",
    subMenus: [
      {
        id: "3.1",
        path: "/daybook",
      },
      {
        id: "3.10",

        path: "/addTransaction",
      },
      {
        id: "3.2",
        path: "/trialBalance",
      },
      {
        id: "3.3",
        path: "/bankBook",
      },
      {
        id: "3.4",
        path: "/fixedAssets",
      },
      {
        id: "3.5",
        path: "/liabilities",
      },
      {
        id: "3.6",
        path: "/profitLoss",
      },
      {
        id: "3.7",
        path: "/balanceSheet",
      },
      {
        id: "3.8",
        path: "/cashflow",
      },
      // {
      //   id: "3.9",
      //   name: "GST Report",
      //   subName: "GST",
      //   path: "/gstReport",
      //   icon: <TbReport size={20} style={{ color: "#fff" }} />
      // },
      // {
      //   id: 1.10,
      //   name: "TDS Report",
      //   subName: "TDS",
      //   path: "/tdsReport",
      //   icon: <TbReportAnalytics size={20} style={{ color: "#fff" }} />
      // }
    ],
  },

  {
    id: 4,
    name: "Master Management",
    subMenus: [
      {
        id: "4.1",
        path: "/accountType",
      },
      {
        id: "4.10",
        path: "/addAccountType",
      },
      {
        id: "4.11",
        path: "/updateAccountType",
      },
      {
        id: "4.2",
        path: "/accountGroup",
      },
      {
        id: "4.3",
        path: "/reportGroup",
      },
      {
        id: "4.4",
        path: "/addReportGroup",
      },
      {
        id: "4.5",
        path: "/GroupList",
      },
      {
        id: "4.20",
        path: "/addAccountGroup",
      },
      // {
      //   id: "4.3",
      //   name: "Report Group",
      //   subName: "Report Group",
      //   path: "/reportGroup",
      //   subPath: "/addReportGroup",
      //   icon: <AiFillAccountBook size={20} style={{ color: "#fff" }} />,
      // },
      {
        id: "4.4",
        path: "/kycImplemenation",
      },
      {
        id: "4.4",
        path: "/addKYCFields",
      },
      {
        id: "4.5",
        path: "/preferences",
      },
      {
        id: "4.6",
        path: "/narration",
      },
      {
        id: "4.7",
        path: "/add-narration",
      },
      {
        id: "4.8",
        path: "/account-code",
      },

      {
        id: "4.9",
        path: "/add-account-code",
      },

      {
        id: "4.0.1",
        path: "/account-transaction-type",
      },
      {
        id: "4.0.2",
        path: "/add-account-transaction-type",
      },
      {
        id: "4.0.3",
        path: "/company-configuration",
      },
      {
        id: "4.0.4",
        path: "/company-configuration-add",
      },
      {
        id: "4.21",
        path: "/add-account-group-configurations",
      },
      {
        id: "4.22",
        path: "/add-account-numbering",
      },
      {
        id: "4.23",
        path: "/project-group",
      },
      {
        id: "4.24",
        path: "/project-group-add",
      },
      {
        id: "4.25",
        path: "/tags",
      },
      {
        id: "4.26",
        path: "/add-tag",
      },
      {
        id: "4.27",
        path: "/tax-configuration",
      },

      {
        id: "4.22",
        path: "/add-account-group-configurations",
      },
    ],
  },

  {
    id: 5,
    name: "Voucher",
    path: "/voucherTemplate",
    subMenus: [
      {
        id: "5.1",
        path: "/createVoucherTemp",
      },
      {
        id: "5.2",
        path: "/editTemplate",
      },
    ],
  },

  {
    id: 6,
    name: "Third Party Api Integration",
    path: "/vendorTemplate",
    // name: "Vendor Template",
    // path: "/vendorTemplate",
    subMenus: [
      {
        id: "6.1",
        path: "/mapData",
      },
      {
        id: "6.2",
        path: "/config-apis",
      },
      // More vendor template items...
    ],
  },

  {
    id: 7,
    path: "/reportsMaster",
  },
  {
    id: 20,
    name: "Bank Reconciliation",
    path: "/bankReconciliation",
  },
  {
    id: 35,
    path: "/help",
  },

  {
    id: 8,
    name: "Payable Reports",
    subMenus: [
      {
        id: "8.1",
        path: "/aging-Summary-Details",
      },
      {
        id: "8.2",
        path: "/vendor-Balance-Summary",
      },
      {
        id: "8.3",
        path: "/unpaid-Bills-Details",
      },
      {
        id: "8.4",
        path: "/accounts-Payable-Summary",
      },
      // More vendor template items...
    ],
  },
  {
    id: 9,
    name: "Receivable Reports",
    subMenus: [
      {
        id: "9.1",
        path: "/receivable/aging-summary",
      },
      {
        id: "9.2",
        path: "/receivable/customer-balance-summary",
      },
      {
        id: "9.3",
        path: "/receivable/invoice-list-summary",
      },
      {
        id: "9.4",
        path: "/receivable/account-receivable-summary",
      },
    ],
  },
  {
    id: 10,
    name: "Over Due Analysis",
    path: "/over-due-analysis",
  },
  {
    id: 11,
    name: "GST",
    path: "/gst-login",
  },
  {
    id: 29,
    path: "/gst/gst-details-portal",
  },
  {
    id: 26,
    path: "/gst/gst-1",
  },
  {
    id: 27,
    path: "/gst/gst-2",
  },
  {
    id: 28,
    path: "/gst/gst-3B",
  },
  {
    id: 30,
    path: "/gst/reconciliation-report",
  },
  {
    id: 12,
    path: "/items-hsncode-management",
    subMenus: [
      {
        id: 12.1,
        path: "/items-hsncode-management/add-item-details",
      },
      {
        id: 12.2,
        path: "/items-hsncode-management/add-HSN-code-details",
      },
      {
        id: 12.3,
        path: "/items-hsncode-management/HSN-Code-list",
      },
    ],
  },
  {
    id: 13,
    name: "Tax Configuration",
    subMenus: [
      {
        id: "13.1",
        path: "/tax-configuration",
      },
      {
        id: "13.2",
        path: "/tax-configuration/tax-section",
      },
      {
        id: "13.3",
        path: "/tax-configuration/tax-rule",
      },
      {
        id: "13.4",
        path: "/tax-configuration/tax-rule/add",
      },
    ],
  },
  {
    id: 13.1,
    name: "Reconciliation",
    subMenus: [
      {
        id: "13.1.1",
        path: "/bank-reconciliation",
      },
      {
        id: "13.1.2",
        path: "/reconciled-statement",
      },
    ],
  },
  {
    id: 14,
    name: "Settings",
    subMenus: [
      {
        id: "14.1",
        path: "/role-permission-mapping",
      },
      {
        id: "14.2",
        path: "/add-role-permission",
      },
    ],
  },
];

// Function to hold api call
export function debounceFunc(cb, delay) {
  let timeout;
  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      cb(...args);
    }, delay);
  };
}

// Function to block specific characters for type number
export const blockInvalidChar = (e) =>
  ["e", "E", "+", "-"].includes(e.key) && e.preventDefault();

export const checkPermissionExist = (endPoints, api) => {
  var parts = api && api.split("/");
  // var updatedApi = parts && "/" + parts.slice(1).join("/");

  var updatedApi = parts && "/" + parts.join("/");

  return endPoints?.some((val) => val.apiEndpoint === updatedApi);
  // return true;
};

export const checkPathExist = (endPoints, path) => {
  const pathExist = endPoints && endPoints.some((val) => val?.path == path);
  return pathExist;
};

export const checkModuleExist = (endPoints, moduleName) => {
  const pathExist =
    endPoints && endPoints.some((val) => val?.name == moduleName);
  return pathExist;
};

export const checkIsHeadOffice = (siteList, selectedSiteId) => {
  const foundSite = siteList?.find(
    (site) => site.id == selectedSiteId && site.isHeadOffice === true
  );
  return !!foundSite;
};

export function updateNestedItem(data, updatedItem) {
  return data.map((item) => {
    if (item?.id == updatedItem?.id) {
      // If the current item matches the updated item, return the updated item
      return updatedItem;
    } else if (item.childList && item.childList.length > 0) {
      // If the current item has a childList, recursively update the childList
      return {
        ...item,
        childList: updateNestedItem(item.childList, updatedItem),
      };
    } else {
      // If no match is found, return the current item unchanged
      return item;
    }
  });
}

export function zeroBalanceReportFilter(childList) {
  // accountGroupCurrentBalance
  // accountGroupDebitBalance
  // accountGroupCreditBalance
  // console.log(childList);
  const tempFilter =
    childList?.length > 0 &&
    childList?.filter(
      (ele, i) =>
        +ele?.accountGroupCurrentBalance !== 0 ||
        +ele?.accountGroupDebitBalance !== 0 ||
        +ele?.accountGroupCreditBalance !== 0
    );
  return tempFilter;
}

export function heightCalculate(data, rowHeight, maxHeight) {
  let height = 0;
  if (data?.length > 0) {
    height = data?.length * rowHeight;
  }
  if (height > maxHeight) {
    height = maxHeight;
  }
  return height;
}
